import { useContext, useCallback } from 'react'
import usersFilterContext from '../../contexts/users-filter'

const useUsersFilter = () => {
    const { filters, setFilters } = useContext(usersFilterContext)

    const {
        limit,
        offset,
        rolesCode,
        searchString,
        gradYearMinimum,
        gradYearMaximum,
    } = filters || {}

    const updateFilters = useCallback((filterOverrides = {}) => {
        setFilters({ ...filters, ...filterOverrides})
    }, [filters, setFilters])

    //  Convenience methods
    const setSearchString = useCallback(searchString => {
        updateFilters({ searchString })
    }, [updateFilters])

    const setOffset = useCallback(offset => {
        updateFilters({ offset })
    }, [updateFilters])

    return {
        //  Available filters
        limit,
        offset,
        rolesCode,
        searchString,
        gradYearMinimum,
        gradYearMaximum,
        //  Setters
        setSearchString,
        setOffset,
        //  General stuff
        filters,
        setFilters,
        updateFilters
    }
}

export default useUsersFilter
